import uid from 'tiny-uid';
import styled, { keyframes, css } from 'styled-components';

const opacityAnimation = keyframes`
  0% {
    opacity: 0.5;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.5;
  }
`;

const SearchArtistLoaderContainer = styled.div`
  position: absolute;
  width: 100%;
`;

const animation = (props) => css`
  ${opacityAnimation} ${props.$animationLength} 3s linear infinite
`;

const SearchLoadingIndicator = styled.li.attrs((props) => ({
  style: {
    width: `${props.width}px`,
    animationDelay: `${props.$delay * 0.15}s`,
    animation: `${animation}`
  }
}))`
  display: flex;
  transform: translateZ(1px);
  background: var(--blue);
  height: 20px;
  margin: 5px 0;
`;

const generateRandomNumber = () => Math.floor(Math.random() * 140) + 140;

const SearchArtistLoader = () => {
  const randomArray = [
    generateRandomNumber(),
    generateRandomNumber(),
    generateRandomNumber(),
    generateRandomNumber(),
    generateRandomNumber(),
    generateRandomNumber(),
    generateRandomNumber(),
    generateRandomNumber(),
    generateRandomNumber(),
    generateRandomNumber(),
    generateRandomNumber()
  ];
  return (
    <SearchArtistLoaderContainer>
      {randomArray.map((width, index) => (
        <SearchLoadingIndicator key={uid()} width={width} $delay={index} />
      ))}
    </SearchArtistLoaderContainer>
  );
};

export default SearchArtistLoader;
